<script>
import AnalysisTableCommentsListVue from 'Modules/contacard/analysisTable/components/tables/AnalysisTableCommentsList.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';

export default {
  name: 'AnalysisTableReasonsList',
  extends: AnalysisTableCommentsListVue,
  data: () => ({
    headers: [
      {
        text: 'Motivo',
        value: 'message',
      },
      {
        text: 'Data de criação',
        value: 'createdAt',
        component: DataTableDateColumnVue,
      },
    ],
  }),
  methods: {
    makeDefaultParams() {
      return {
        RegisterClientId: this.getId,
        Type: 'AnalysisTable',
      };
    },
  },
};
</script>
